import { render } from "./EditSalaryDeductionComponent.vue?vue&type=template&id=52fb57cc&scoped=true"
import script from "./EditSalaryDeductionComponent.vue?vue&type=script&lang=js"
export * from "./EditSalaryDeductionComponent.vue?vue&type=script&lang=js"

import "./EditSalaryDeductionComponent.vue?vue&type=style&index=0&id=52fb57cc&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52fb57cc"]])

export default __exports__